import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router';
// import Content from '../components/Content';
// import PdfViewer from '../components/PdfViewer';
//import firebase from 'firebase';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';

import PdfViewer from './PdfViewer';
import WithAdmin from '../../components/WithAdmin';
import { Header, Content } from '../../components';
import { pdfBySlug } from '../../queries';

class PdfView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      supp: [],
      error: false,
    };
  }

  render() {
    const { match } = this.props;
    console.log(this.props);
    return (
      <div>
        <Content>
          <div>
            <WithAdmin>
              {(isAdmin, role) => (
                <Query
                  // ssr={false}
                  query={pdfBySlug}
                  variables={{ slug: match.params.slug }}
                  fetchPolicy={'network-only'}
                >
                  {({
                    data: pdfBySlug,
                    error: pdfBySlugError,
                    loading: pdfBySlugLoading,
                  }) => {
                    console.log(pdfBySlug, pdfBySlugError, pdfBySlugLoading);
                    return pdfBySlugLoading ? (
                      <Typography>loading...</Typography>
                    ) : pdfBySlugError || !pdfBySlug?.pdfBySlug ? (
                      <Typography variant="caption" color="error">
                        Sorry, that pdf doesn't exist
                      </Typography> //pdfBySlug.error.message
                    ) : (
                      <div>
                        <PdfViewer
                          authed={this.props.isLogged}
                          canEdit={
                            role &&
                            role !== 'ajn_pdfs_user' &&
                            role !== 'ajn_pdfs_author'
                          }
                          match={this.props.match}
                          history={this.props.history}
                          goBack={this.props.history.goBack}
                          location={this.props.location}
                          pdf={pdfBySlug.pdfBySlug}
                        />
                      </div>
                    );
                  }}
                </Query>
              )}
            </WithAdmin>
          </div>
        </Content>
      </div>
    );
  }
}

PdfView.propTypes = {
  isLogged: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isLogged: state.root.auth.isLogged,
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps)
  // graphql(pdfBySlug, {
  // name: 'pdfBySlug',
  //   options: ({match}) => ({
  //     variables: { slug: match.params.slug }
  //   }),
  // }),
)(PdfView);
